import { cn } from '@/lib/utils'
import React from 'react'

type UserMessageProps = {
  message: string
  isFirstMessage?: boolean
}

export const UserMessage: React.FC<UserMessageProps> = ({
  message,
  isFirstMessage
}) => {
  return (
    <div className={cn({ 'mt-4': !isFirstMessage }, 'flex justify-end')}>
      <div className=" max-w-[60%] rounded-2xl rounded-br-none px-5 py-2.5 chat-bubble relative bg-gray-100">
        <div className="text-base">{message}</div>
      </div>
    </div>
  )
}
